module.exports = __webpack_public_path__ + "static/media/Luxray_gaussian2.0accf082.png";